import {
  ExternalRouteRef,
  RouteRef,
  SubRouteRef,
  createExternalRouteRef,
  createRouteRef,
} from '@backstage/core-plugin-api';

import { createPageRoute } from '@spotify/confidence-common-react';

export enum RoutesIds {
  issues = 'issues',
  issue = 'issue',
  themes = 'themes',
}

enum ExternalRoutesIds {
  chat = 'chat',
  github = 'github',
}

export const issuesRouteRef = createPageRoute({
  id: 'issue-index',
  page: { title: 'Loop' },
});

export const rootRouteRef = issuesRouteRef;

export const issueRouteRef = createPageRoute({
  id: RoutesIds.issue,
  route: { path: '/:id', parent: rootRouteRef },
  page: { title: 'Issue' },
});

export const themesRouteRef = createRouteRef({
  id: RoutesIds.themes,
});

export const chatRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.chat,
  params: ['id'],
  optional: true,
});

export const githubRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.github,
  optional: true,
});

export const Routes = {
  issues: issuesRouteRef,
  issue: issueRouteRef,
  themes: themesRouteRef,
} satisfies Record<RoutesIds, SubRouteRef | RouteRef>;

export const ExternalRoutes = {
  chat: chatRouteRef,
  github: githubRouteRef,
} satisfies Record<ExternalRoutesIds, ExternalRouteRef>;
